import {
    DEBUG_MODE,
    DEV_MODE,
} from '../../utils/env'

/**
 * Configuração base de resiliência do hls.js, compartilhada pelas páginas que
 * usam o limitador de download de segmentos (.ts).
 *
 * Foco: reduzir a ocorrência do erro `hls:3` (MEDIA_ERR_DECODE no playback HLS
 * do Clappr), que normalmente vem de stalls de buffer / falhas transitórias de
 * decode e que o Clappr NÃO recupera sozinho no caminho do erro nativo do
 * <video>.
 *
 * Observação importante: o hls.js faz merge *raso* da config (`mergeConfig`).
 * Por isso o `fragLoadPolicy.default` precisa ser fornecido COMPLETO — um objeto
 * parcial substituiria o default inteiro e quebraria o carregamento de
 * fragmentos.
 */
export const RESILIENCE_HLS_CONFIG = {
    // Recuperação de stall — principal gatilho do hls:3.
    nudgeOffset: 4,            // default 0.1 — empurra o playhead pra sair do stall
    nudgeMaxRetry: 30,         // default 3   — tentativas antes de declarar FATAL
    maxBufferHole: 0.5,        // default 0.1 — pula buracos pequenos no buffer
    appendErrorMaxRetry: 6,    // default 3   — re-append no MSE (decode recuperável)
    backBufferLength: 30,      // default Infinity — libera memória sem afetar o download à frente

    // Resiliência de rede para o hls.js antigo embutido no Clappr 0.2.x.
    // Evita ficar tempo demais preso em requests canceladas / ERR_CONNECTION_TIMED_OUT
    // antes de permitir que o Player avance para a próxima source de fallback.
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 8000,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 2,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 8000,
    fragLoadingTimeOut: 10000,
    fragLoadingMaxRetry: 2,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 8000,

    // Resiliência de rede para hls.js moderno (policy COMPLETA por causa do
    // merge raso do hls.js).
    fragLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 120000,
            timeoutRetry: { maxNumRetry: 6, retryDelayMs: 0, maxRetryDelayMs: 0 },
            errorRetry: { maxNumRetry: 8, retryDelayMs: 1000, maxRetryDelayMs: 8000 },
        },
    },

    debug: DEBUG_MODE || DEV_MODE,
}
